import { type DashRouteType, URL_RETAILER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_FULFILLMENT_SETTINGS = `${URL_RETAILER_SCOPED}/fulfillment-settings`
const URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES = `${URL_FULFILLMENT_SETTINGS}/order-orchestration`
const URL_FULFILLMENT_SETTINGS_CREATE_FULFILLMENT_RULE = `${URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES}/create`
const URL_FULFILLMENT_SETTINGS_BANNER_RULE_MANAGEMENT = `${URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES}/banner/:bannerId`
const URL_FULFILLMENT_SETTINGS_STORE_RULE_MANAGEMENT = `${URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES}/store/:bannerId/:storeId`
const URL_FULFILLMENT_SETTINGS_EDIT_FULFILLMENT_RULE = `${URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES}/:ruleId/edit`
const URL_FULFILLMENT_SETTINGS_MANAGE_PROVIDERS = `${URL_FULFILLMENT_SETTINGS}/manage-providers`
const URL_FULFILLMENT_SETTINGS_EDIT_PROVIDER = `${URL_FULFILLMENT_SETTINGS_MANAGE_PROVIDERS}/:providerId/edit`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'fulfillment-settings'>
  | DashRouteType<'fulfillment-settings-list-fulfillment-rules'>
  | DashRouteType<'fulfillment-settings-create-fulfillment-rule'>
  | DashRouteType<'fulfillment-settings-banner-rule-management'>
  | DashRouteType<'fulfillment-settings-store-rule-management'>
  | DashRouteType<'fulfillment-settings-edit-fulfillment-rule'>
  | DashRouteType<'fulfillment-settings-manage-providers'>
  | DashRouteType<'fulfillment-settings-edit-provider'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'fulfillment-settings': URL_FULFILLMENT_SETTINGS,
  'fulfillment-settings-list-fulfillment-rules': URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES,
  'fulfillment-settings-create-fulfillment-rule': URL_FULFILLMENT_SETTINGS_CREATE_FULFILLMENT_RULE,
  'fulfillment-settings-banner-rule-management': URL_FULFILLMENT_SETTINGS_BANNER_RULE_MANAGEMENT,
  'fulfillment-settings-store-rule-management': URL_FULFILLMENT_SETTINGS_STORE_RULE_MANAGEMENT,
  'fulfillment-settings-edit-fulfillment-rule': URL_FULFILLMENT_SETTINGS_EDIT_FULFILLMENT_RULE,
  'fulfillment-settings-manage-providers': URL_FULFILLMENT_SETTINGS_MANAGE_PROVIDERS,
  'fulfillment-settings-edit-provider': URL_FULFILLMENT_SETTINGS_EDIT_PROVIDER,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
